import { normalizeQuery } from './normalizeQuery';

/** First letter of each whitespace-separated word after normalize. */
export const acronymFromPhrase = (text: string): string => {
  const normalized = normalizeQuery(text);
  if (!normalized) return '';
  return normalized
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word[0] ?? '')
    .join('');
};

/**
 * Contiguous alphanumeric query suitable for acronym matching.
 * Requires length ≥ 2 and no whitespace.
 */
export const isAcronymQuery = (query: string): boolean => {
  const normalized = normalizeQuery(query);
  if (normalized.length < 2) return false;
  if (/\s/.test(normalized)) return false;
  return /^[a-z0-9]+$/.test(normalized);
};

/** Exact or prefix match of query against acronyms derived from phrases. */
export const matchesAcronym = (
  query: string,
  phrases: string[],
): boolean => {
  const normalized = normalizeQuery(query);
  if (!isAcronymQuery(normalized)) return false;

  return phrases.some((phrase) => {
    const acronym = acronymFromPhrase(phrase);
    if (acronym.length < 2) return false;
    return acronym === normalized || acronym.startsWith(normalized);
  });
};
